/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type {
  GetTransportsModelsBrandIdQueryResponse,
  GetTransportsModelsBrandIdPathParams,
  GetTransportsModelsBrandIdQueryParams,
  GetTransportsModelsBrandId400,
} from '../entities/GetTransportsModelsBrandId'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'

function getGetTransportsModelsBrandIdUrl(brand_id: GetTransportsModelsBrandIdPathParams['brand_id']) {
  return `/transports/models/${brand_id}` as const
}

/**
 * @description Get all transport models
 * @summary Get all transport models
 * {@link /transports/models/:brand_id}
 */
export async function getTransportsModelsBrandId(
  brand_id: GetTransportsModelsBrandIdPathParams['brand_id'],
  params?: GetTransportsModelsBrandIdQueryParams,
  config: Partial<RequestConfig> & { client?: typeof client } = {},
) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<GetTransportsModelsBrandIdQueryResponse, ResponseErrorConfig<GetTransportsModelsBrandId400>, unknown>({
    method: 'GET',
    url: getGetTransportsModelsBrandIdUrl(brand_id).toString(),
    params,
    ...requestConfig,
  })
  return res.data
}